<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title v-text="data.last_visited_ip" />
      <v-list-item-subtitle v-text="lastActiveAt" />
    </v-list-item-content>

    <v-list-item-action>
      <BTooltipButton
        :loading="loading"
        icon="mdi-close"
        tooltip="Выйти"
        depressed
        small
        top
        @click="$emit('logout-session', data, toggle)"
      />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { getLastActiveAt } from '@/helpers/dateFormatter'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'UsersSessionListItem',
  components: {
    BTooltipButton,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    lastActiveAt() {
      const value = this.data.last_active_at
      return value && getLastActiveAt(value, 2)
    },
  },
  methods: {
    toggle() {
      this.loading = !this.loading
    },
  },
}
</script>
